import { Box, Grid } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { MultiKillsComponent } from '../../components/statistics/multiKills'
import { TopChampionsComponent } from '../../components/statistics/topChampions';
import { AllChampionsComponent } from '../../components/statistics/allChampions';
import { MostContestedChampionsComponent } from '../../components/statistics/mostContestedChampions';
import { TopUniqueChampionsComponent } from '../../components/statistics/topUniqueChampions';
import { TopDamageStatsComponent } from '../../components/statistics/topDamageStats';
import { ControlWardsStatsComponent } from '../../components/statistics/goldWaster';
import { EnemyJungleStatsComponent } from '../../components/statistics/enemyJungleStats';
import { TopRoleWinratesComponent } from '../../components/statistics/topRoleWinrates';
import { GoldEarnedComponent } from '../../components/statistics/topGold';
import { TotalKDAComponent } from '../../components/statistics/totalKda';
import { WinrateBySide } from '../../components/overall/winrateBySide';
import ErrorBoundary from '../../components/errorBoundary';

export const Route = createFileRoute('/statistics/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Box mx={4}>
      <Box mt={4}>
        <ErrorBoundary>
          <TopChampionsComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <AllChampionsComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <MultiKillsComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <MostContestedChampionsComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <TopUniqueChampionsComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <TopDamageStatsComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <Grid container spacing={2}>
          <Grid size={6}>
            <ErrorBoundary>
              <ControlWardsStatsComponent />
            </ErrorBoundary>
          </Grid>
          <Grid size={6}>
            <ErrorBoundary>
              <EnemyJungleStatsComponent />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <TopRoleWinratesComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <GoldEarnedComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <TotalKDAComponent />
        </ErrorBoundary>
      </Box>

      <Box mt={4}>
        <ErrorBoundary>
          <WinrateBySide />
        </ErrorBoundary>
      </Box>
    </Box>
  );
}
